import { Order } from '~src/spacesPlatform/models/sort/Order';
import { OptionsDictionary } from '~src/spacesPlatform/models/sort/SortOptionDefinitions';
import { createNonDisplayOptionDefinition } from '~src/spacesPlatform/models/sort/SortOptionsHelper';

import { OrderKeys } from '../../../../spacesPlatform/models/OrderKeys';

export const defaultUserSort = [Order.asc(OrderKeys.displayName)];

export const userSortOptions: OptionsDictionary = {
  'userName': createNonDisplayOptionDefinition('userName', OrderKeys.username),
  'displayName': createNonDisplayOptionDefinition('displayName', OrderKeys.displayName),
  'domainName': createNonDisplayOptionDefinition('domainName', OrderKeys.domainName),
};
